import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { variablesData } from '../mockData/variables-data';

const VariablesApi = [
  rest.get(`${API_ROOT}patient-data-variables`, (req, res, ctx) => res(ctx.json(variablesData))),
  rest.patch(`${API_ROOT}patient-data-variables/${variablesData.data.vars[0].id}`, (req, res, ctx) => res(ctx.json(variablesData.data.vars[0]))),
  rest.post(`${API_ROOT}patient-data-variables`, (req, res, ctx) => res(ctx.json(variablesData.data.vars[0]))),
  rest.get(`${API_ROOT}patient-data-variables/${variablesData.data.vars[0].id}`, (req, res, ctx) => res(ctx.json(variablesData.data.vars[0]))),
];
export default VariablesApi;
